module.exports = __webpack_public_path__ + "img/radio-tuner.879d5ceb.svg";